import {
  Compiler,
  EventEmitter,
  Injectable,
  Injector,
  NgModuleFactory,
} from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, ReplaySubject, of, map } from 'rxjs';
import { EnvironmentService } from '../service/service.module';

@Injectable({ providedIn: 'root' })
export class AmazonScraperService {
  environment = EnvironmentService.environment;
  constructor(public http: HttpClient) { }

  ScraperRequestSubmit(model: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain',
      }),
    };
    // console.log(model);
    return this.http.post<Array<any>>(
      `${this.environment.AmazonScraperBuyBox}/ScrapTextFile?FileName=${model.fileName}&TriggerType=${model.triggerType}&ScheduleTime=${model.scheduleTime}&Comment=${model.comment}&recurrenceType=${model.recurrenceType}&userId=${model.userId}`,
      model.file,
      httpOptions
    );
  }
  GetScraperRequestStatus(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AmazonScraperRequest}/Get`, {
      params,
    });
  }
  DownloadInputFile(requestid: any): Observable<any> {
    return this.http.get(`${this.environment.AmazonScraperRequest}/DownloadInputFile?requestId=${requestid}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  DownloadResultFile(requestid: any): Observable<any> {
    console.log('downloadresult-1')
    return this.http.get(`${this.environment.AmazonScraperRequest}/DownloadResultFile?requestId=${requestid}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  DeleteRequest(requestid: any, userId: any): Observable<any> {
    return this.http.delete<any>(`${this.environment.AmazonScraperRequest}/DeleteRequest?requestId=${requestid}&userId=${userId}`);
  }
  GetScraperSchedules(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AmazonScraperRequest}/GetScraperSchedules`, {
      params,
    });
  }

  UpdateSchedule(model: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain',
      }),
    };
    return this.http.post<Array<any>>(
      `${this.environment.AmazonScraperBuyBox}/UpdateSchedule?FileName=${model.fileName}&TriggerType=${model.triggerType}&ScheduleTime=${model.scheduleTime}&Comment=${model.comment}&recurrenceType=${model.recurrenceType}&scheduleId=${model.scheduleId}&userId=${model.userId}`,
      model.file,
      httpOptions
    );
  }
  DownloadScheduleInputFile(requestid: any): Observable<any> {
    return this.http.get(`${this.environment.AmazonScraperRequest}/DownloadScheduleInputFile?requestId=${requestid}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  DeleteScheduleRequest(requestid: any, userId: any): Observable<any> {
    return this.http.delete<any>(`${this.environment.AmazonScraperRequest}/DeleteScheduleRequest?requestId=${requestid}&userId=${userId}`);
  }
}
